import icon from "~/components/ui/icons/svg/logo.svg";

export const Logo = ({ width = "90", height = "15" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 486 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <use xlinkHref={`#${icon}`} />
    </svg>
  );
};
